import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingComponent = () => (
  <div style={styles.loadingContainer}>
    <Spinner animation="border" role="status" style={styles.spinner}>
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

const styles = {
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height
    width: '100%', // Full viewport width
    backgroundColor: 'rgba(0, 0, 0, 0)', // transparent background
    position: 'fixed', // Fixed position to cover the whole screen
    top: 0,
    left: 0,
    zIndex: 1050, // Bootstrap's modal z-index is 1040, so 1050 is above modals
  },
  spinner: {
    width: '3rem',
    height: '3rem',
    borderWidth: '0.5em',
  },
};

export default LoadingComponent;
